// extracted by mini-css-extract-plugin
module.exports = {"editorButton":"editorbutton-module--editorButton--2xFRc","updateButton":"editorbutton-module--updateButton--1PUSl","cancelButton":"editorbutton-module--cancelButton--mliT9"};